"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDebug = isDebug;
exports.debugLog = debugLog;
const cookies_1 = require("./cookies");
function isDebug(options = {}) {
    const { debug: debugOption = false } = options;
    const debug = debugOption || (0, cookies_1.isDebugCookieSet)();
    return debug;
}
function debugLog(options = {}, ...args) {
    const debug = isDebug(options);
    const prefix = '[ONE SEGMENT]';
    args[0] = `${prefix} ${args[0]}`;
    if (debug) {
        console.log(...args);
    }
}
//# sourceMappingURL=debugHelper.js.map